import React, { ChangeEvent, FC } from 'react'
import { BreadType } from 'types/bread'
import { Card } from 'components/Card'
import TimeSaleProductCard from './TimeSaleProductCard'
import { HorizontalLine } from 'components/Utility'
import { getBreadShortName } from 'lib/helper'
import { StockType } from 'types/stock'

type Props = {
  breads: BreadType[]
  selectedBreads: BreadType[]
  selectBread: (event: ChangeEvent<HTMLInputElement>) => void
  stocks: StockType[]
}

const TimeSaleProductCardList: FC<Props> = (props) => {
  const { breads, selectedBreads, selectBread, stocks } = props
  return (
    <Card>
      {breads.map((bread, index) => {
        if (!bread.bread_ref) return
        const isSelected = selectedBreads.some((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id)
        const preorderStocks = stocks.filter(
          (stock) => stock.bread_ref.id === bread.bread_ref?.id && stock.type === 'preorder'
        )
        return (
          <React.Fragment key={bread.bread_ref.id}>
            {index !== 0 && <HorizontalLine verticalMargin={16} />}
            <TimeSaleProductCard
              breadId={bread.bread_ref.id}
              breadName={getBreadShortName(bread)}
              imageUrl={bread.image_urls[0] || ''}
              isSelected={isSelected}
              isTypeDaily={bread.is_type_daily}
              isTypePreorder={bread.is_type_preorder}
              isTypeDelivery={bread.is_type_delivery}
              preorderStocks={preorderStocks}
              selectBread={selectBread}
            />
          </React.Fragment>
        )
      })}
    </Card>
  )
}

export default TimeSaleProductCardList
